import type { SVGProps } from 'react'
const SvgSyError = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12 17.6c.3 0 .6-.1.8-.3s.3-.5.3-.8-.1-.6-.3-.8-.5-.3-.8-.3-.6.1-.8.3-.3.5-.3.8.1.6.3.8.5.3.8.3m-1.1-4.5h2.3V6.3h-2.3zM12 23.3c-1.6 0-3-.3-4.4-.9S5 21 4 20s-1.8-2.2-2.4-3.6S.7 13.6.7 12s.3-3 .9-4.4S3 5 4 4s2.2-1.8 3.6-2.4S10.4.7 12 .7s3 .3 4.4.9S19 3 20 4s1.8 2.2 2.4 3.6.9 2.8.9 4.4-.3 3-.9 4.4S21 19 20 20s-2.2 1.8-3.6 2.4-2.8.9-4.4.9" />
	</svg>
)
export default SvgSyError
